import {WidgetType} from '@codemirror/view'
import {clsx} from 'clsx'

import styles from '../extensions/decorate-markdown.module.css'

export const ThematicBreakWidget = new (class extends WidgetType {
  toDOM() {
    const element = document.createElement('hr')
    element.className = clsx(styles.block)
    return element
  }

  override eq() {
    return true
  }

  override ignoreEvent() {
    return false
  }
})()
